import { Api } from "./Api";
import { Email } from "../models/Email";

export class EmailApi extends Api {
    constructor() {
        super("mail/send");
    }

    create(email: Email): Promise<any> {
        return this.createResource(email);
    }
}
